<template>
    <div class="flex-1 flex justify-center">
        <div class="w-full">
            <label for="search" class="sr-only">Search}</label>
            <div class="flex rounded-md shadow-sm">
                <div class="relative flex items-stretch flex-grow">
                    <input id="search"
                           class="h-input block w-full py-2 pr-3 border border-cyan-700 leading-5 text-white-900 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-offset-cyan-500 focus:ring-cyan-500 focus:border-white sm:text-sm"
                           :placeholder="placeholder"
                           :value="modelValue"
                           @input="$emit('update:modelValue', $event.target.value)"
                           autocomplete="off"
                           type="search"
                           name="search"/>

                    <link-button @click="$emit('reset')">Reset</link-button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import LinkButton from "@/Jetstream/LinkButton";

export default {
    name: "SearchBar",
    props: ['placeholder', 'modelValue'],
    emits: ['update:modelValue', 'reset'],
    components: {
        LinkButton,
    }
}
</script>

<style scoped>

</style>
